import React, { useCallback, useState } from "react";

import { useNavigate } from "react-router-dom";
import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  position: relative;
`;

const PageTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #dddddd;
  background-color: #fff;
  padding: 30px 0;
  font-size: 1.13em;
  position: relative;
  .pagetit {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 2.5vw;
    font-family: "spoqa500";
  }
  .move-btn {
    position: absolute;
    height: 100%;
    top: 0;
    right: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    & img {
      cursor: pointer;
      width: 100%;
    }
  }

  @media screen and (min-width: 1050px) {
    font-size: 1.4em;
    p {
      & img {
        width: 30%;
      }
    }
  }
`;

const SelectInsect = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const InsectItem = styled.div`
  width: 15%;
  margin-left: 5vw;
  margin-top: 51px;

  :first-child {
    margin-left: 0;
  }

  img {
    width: 100%;
    border-radius: 50%;
    border: 1px solid #d8d7d7;
    background-color: #dddddd !important;
    cursor: pointer;
  }
  p {
    text-align: center;
    font-size: 1.5vw;
    font-family: "Spoqa700";
  }
`;

const ModalCon = styled.div`
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
  border: 1px solid gold;
  z-index: 999;

  div {
    box-shadow: -1px 1px 8px 4px #fff;
    width: 60%;
    height: 500px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    font-size: 2vw;
    opacity: 1;
    position: absolute;
    background-color: #fff;
  }
  div img {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 20px;
    cursor: pointer;
  }
  div p {
    width: 45%;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    margin-left: 20px;
    box-shadow: 0px 1px 10px 0px #564a4a;
  }
`;

const SelectBtn = styled.div`
  margin: 100px 30px;
  background-color: rgba(247, 247, 247, 1);
  /* box-shadow: rgba(0, 0, 0, 0.25); */
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  width: 163px;
  height: 43px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
`;

const SelectSetting = () => {
  const navigate = useNavigate();

  const Navigatefunc = useCallback((type: string) => {
    if (type === "Critical") {
      navigate("/Critical");
    } else if (type === "Feedmanagement") {
      navigate("/Feedmanagement");
    } else if (type === "Boxmanagement") {
      navigate("/Boxmanagement");
    }
  }, []);
  return (
    <Container>
      <PageTop>
        <p className="move-btn">
          <img
            src="./img/X.svg"
            onClick={() => {
              navigate("/MainPage");
            }}
            alt="X"
          />
        </p>
      </PageTop>
      <SelectInsect>
        <SelectBtn onClick={() => Navigatefunc("Boxmanagement")}>
          <span>사육상자관리</span>
        </SelectBtn>
        <SelectBtn onClick={() => Navigatefunc("Feedmanagement")}>
          <span>사료관리</span>
        </SelectBtn>
        <SelectBtn onClick={() => Navigatefunc("Critical")}>
          <span>임계치 관리</span>
        </SelectBtn>
      </SelectInsect>
    </Container>
  );
};

export default SelectSetting;
